var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667C11.3807 11.6667 12.5 10.5474 12.5 9.16667C12.5 7.78596 11.3807 6.66667 10 6.66667C8.61929 6.66667 7.5 7.78596 7.5 9.16667C7.5 10.5474 8.61929 11.6667 10 11.6667Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7138 13.8808L11.178 17.4167C10.8655 17.7289 10.4418 17.9042 10.0001 17.9042C9.55836 17.9042 9.13469 17.7289 8.82218 17.4167L5.28551 13.8808C4.3532 12.9485 3.71829 11.7606 3.46108 10.4674C3.20388 9.17419 3.33592 7.83376 3.84051 6.61561C4.34511 5.39745 5.19959 4.35628 6.29591 3.62376C7.39223 2.89123 8.68115 2.50024 9.99968 2.50024C11.3182 2.50024 12.6071 2.89123 13.7034 3.62376C14.7998 4.35628 15.6542 5.39745 16.1588 6.61561C16.6634 7.83376 16.7955 9.17419 16.5383 10.4674C16.2811 11.7606 15.6462 12.9485 14.7138 13.8808V13.8808Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.9702c16f.svg";
export { ForwardRef as ReactComponent };